import { useEffect, useState } from "react";

import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../components/MaterialTypography";

import MaterialBox from "../components/MaterialBox";
import MaterialInput from "../components/MaterialInput";

import MaterialButton from "../components/MaterialButton";

import DashboardLayout from "../layoutcontainers/DashboardLayout";

import MaterialSelect from "../components/MasterSelect";
import { useUserDetails } from "../context/auth";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox,
  ButtonGroup,
} from "@mui/material";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import BASEURL from "../pages/Utils/Baseurl";
import axios from "axios";

import ConfirmationDialog from "../components/Dialog/ConfirmationDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { UpdateSourceScreen } from "./Graphql";
const tableStyles = {
  table: {
    borderCollapse: "collapse",
    // width: "90%", // Increased width
    margin: "0 auto", // Center the table
    // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    borderRadius: "6px",
    "& th, & td": {
      border: "1px solid #ddd",
      textAlign: "center",
      padding: "6px 40px", // Reduced padding for lower height
    },
    "& th": {
      backgroundColor: "#3F51B5d4",
      color: "#fff",
      fontWeight: "600",
      fontSize: "0.9rem",
      textTransform: "uppercase",
    },
    "& td": {
      fontSize: "0.85rem",
    },
    "& tr:hover td": {
      // backgroundColor: "#f3f3f3",
    },
  },
};

const SourceProfile = () => {
  const [selectedRatings, setSelectedRatings] = useState({});
  const location = useLocation();
  const data = location.state;
  console.log(data, "rdsata");

  const characteristics = [
    "Professionalism",
    "Technical Skills",
    "Level of Interest",
    "Learning Ability",
    "Confidence",
    "Attitude",
    "Communication",
  ];
  const navigate = useNavigate();
  const { AccessData } = useUserDetails();

  const ratings = ["Poor", "Fair", "Average", "Good", "Excellent"];

  const ratingValues = {
    Poor: 1,
    Fair: 2,
    Average: 3,
    Good: 4,
    Excellent: 5,
  };

  const handlefeedbback = (event) => {
    const { name, value } = event.target;
    console.log("namenamename:", name, value);

    setSelectedRatings((prev) => ({
      ...prev,
      [name]: ratingValues[value],
    }));
  };

  console.log("selectedRatings:", selectedRatings);

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [feedback, setfeedback] = useState({
    jobid: "",
    candidatename: "",
    date: "",
    position: "",
    department: "",
    interviewer: "",
    comments: "",
    hiringstatus: "",

    jobidStatus: "unchecked",
    candidatenameStatus: "unchecked",
    dateStatus: "unchecked",
    positionStatus: "unchecked",
    departmentStatus: "unchecked",
    interviewerStatus: "unchecked",
    commentsStatus: "unchecked",
    hiringstatusStatus: "unchecked",
  });

  const jobidlist = [
    { value: "Hired", label: "Hired" },
    { value: "Rejected", label: "Rejected" },
    { value: "Immediate", label: "Immediate" },
    { value: "On hold", label: "On hold" },
    { value: "1 Month", label: "1 Month" },
    { value: "2 Month", label: "2 Month" },
    { value: "3 Month", label: "3 Month" },
  ];

  useEffect(() => {
    fetchtechnicalfeedback();
  }, [data]);

  const fetchtechnicalfeedback = () => {
    if (data?.feedbackid) {
      //update
      setTogglePage(() => ({
        view: true,
        edit: false,
      }));
      setSelectedRatings({
        ...selectedRatings,

        professionalism: splitfuntion(data?.professionalism),
        technicalSkills: splitfuntion(data?.technicalSkills),
        levelOfInterest: splitfuntion(data?.levelOfInterest),
        learningAbility: splitfuntion(data?.learningAbility),
        confidence: splitfuntion(data?.confidence),
        attitude: splitfuntion(data?.attitude),
        communication: splitfuntion(data?.communication),
      });
    } else {
      //create
      setTogglePage((prev) => ({
        view: false,
        edit: false,
      }));
    }
    const interviewDate = new Date(data?.interviewdate);

    const indianTime = new Date(
      interviewDate.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
    );

    const formattedDate = indianTime.toISOString().slice(0, 19);
    setfeedback({
      jobid: data?.jobid,
      candidatename: data?.candidateName,
      date: formattedDate,
      position: data?.position,
      department: data?.department,
      interviewer: data?.interviewer,
      comments: data?.comments,
      hiringstatus: { value: data?.hiringStatus, label: data?.hiringStatus },

      jobidStatus: data?.jobid ? "success" : "unchecked",
      candidatenameStatus: data?.candidatename ? "success" : "unchecked",
      dateStatus: data?.interviewdate ? "success" : "unchecked",
      positionStatus: data?.position ? "success" : "unchecked",
      departmentStatus: data?.department ? "success" : "unchecked",
      interviewerStatus: data?.interviewer ? "success" : "unchecked",
      commentsStatus: "unchecked",
      hiringstatusStatus: "unchecked",
    });
  };

  let splitfuntion = (value) => {
    console.log("value:", value);
    let data = value?.split("_").pop();
    console.log(data, "data in splitt");
    let integerData = parseInt(data, 10);
    console.log(integerData, "intdataaa");

    return integerData;
  };

  console.log("feedback:", feedback);

  const handleAddSource = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handleSubmitFeedback();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleSubmitFeedback = async () => {
    const query = `mutation CreateTechnicalFeedback($input: TechnicalFeedbackInput!) {
  createTechnicalFeedback(input: $input) {
    technicalFeedback {
      id
      sourcingScreening {
        id
        candidateName
      }
      professionalism
      comments
      hiringStatus
      technicalSkills
      levelOfInterest
      learningAbility
      confidence
      attitude
      communication
    }
  }
}`;

    const alldata = {
      sourcingScreeningId: data?.sourcingid,
      comments: feedback.comments,
      hiringStatus: feedback.hiringstatus?.value,
      professionalism: selectedRatings.professionalism,
      technicalSkills: selectedRatings.technicalSkills,
      levelOfInterest: selectedRatings.levelOfInterest,
      learningAbility: selectedRatings.learningAbility,
      confidence: selectedRatings.confidence,
      attitude: selectedRatings.attitude,
      communication: selectedRatings.communication,
    };

    console.log("alldata:", alldata);

    try {
      const response = await axios.post(BASEURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        query,
        variables: {
          input: alldata,
        },
      });
      console.log("responsezzzzz:", response.data);

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      const finaldata =
        response.data.data?.createTechnicalFeedback?.technicalFeedback;

      if (finaldata !== "") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Feedback Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/technical");
      }
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteStaff();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteStaff = async () => {
    const query = `
      mutation DeleteFeedback($id: ID!) {
  deleteTechnicalFeedback(id: $id) {
    success
  }
}

        `;

    const alldata = {
      screeningStatus: "Rejected",
    };
    try {
      const [response1, response2] = await Promise.all([
        axios.post(
          BASEURL,
          {
            query: query,
            variables: { id: data?.feedbackid },
          },
          { headers: { "Content-Type": "application/json" } }
        ),
        axios.post(
          BASEURL,
          {
            query: UpdateSourceScreen,
            variables: {
              id: data?.sourcingid,
              input: alldata,
            },
          },
          { headers: { "Content-Type": "application/json" } }
        ),
      ]);

      console.log(
        "response1:",
        response1.data.data.deleteTechnicalFeedback.success
      );
      console.log(
        "response2:",
        response2.data.data.updateSourcingScreening?.sourcingScreening
      );

      let result = response1.data.deleteTechnicalFeedback;

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      if (response1.data.data.deleteTechnicalFeedback.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Feedback Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/technical");
        // setChangevalue({
        //   ...Changevalue,
        //   Changevalue: "Asset Request",
        // });
      }
    } catch (error) {
      console.log("error:", error);
    }
  };

  const handleEdit = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to Update your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        Updatestaffrequest();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const Updatestaffrequest = async () => {
    const query = `
   mutation UpdateTechnicalFeedback($id: ID!, $input: TechnicalFeedbackInput!) {
  updateTechnicalFeedback(id: $id, input: $input) {
    technicalFeedback {
      id
      professionalism
      comments
      hiringStatus
      technicalSkills
      levelOfInterest
      learningAbility
      confidence
      attitude
      communication
    }
  }
}
  `;

    // Ensure staffrequest object is correctly populated
    const alldata = {
      comments: feedback.comments,
      hiringStatus: feedback.hiringstatus.value,
      professionalism: selectedRatings.professionalism,
      technicalSkills: selectedRatings.technicalSkills,
      levelOfInterest: selectedRatings.levelOfInterest,
      learningAbility: selectedRatings.learningAbility,
      confidence: selectedRatings.confidence,
      attitude: selectedRatings.attitude,
      communication: selectedRatings.communication,
    };

    console.log("alldatasssssssss:", alldata);

    try {
      const response = await axios.post(BASEURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        query,
        variables: {
          id: data?.feedbackid,
          input: alldata,
        },
      });

      console.log(
        "responseEDIT:",
        response.data.data.updateTechnicalFeedback.technicalFeedback
      );

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      let finaldata =
        response.data.data.updateTechnicalFeedback.technicalFeedback;

      if (finaldata !== "") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Feedback Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/technical");
      }
    } catch (error) {
      // Handle network or unexpected errors
      console.error("Network or unexpected error:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for the inconvenience, there is an issue with our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      feedback.hiringstatusStatus === "success" &&
      feedback.commentsStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onCancelAction = () => {
    navigate("/technical");
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    {togglePage?.edit
                      ? "Edit"
                      : togglePage?.view
                      ? "View"
                      : "Add"}{" "}
                    Feedback
                  </MaterialTypography>
                </Stack>
                {AccessData &&
                  Array.isArray(AccessData) &&
                  AccessData.some(
                    (item) =>
                      item.component === "EditTechnicalFeedback" &&
                      item.can_access
                  ) &&
                  togglePage.view && (
                    <ButtonGroup
                      variant="outlined"
                      aria-label="Loading button group"
                    >
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        onClick={toggleEdit}
                        startIcon={<EditIcon />}
                      >
                        Edit
                      </MaterialButton>
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        onClick={AddDelete}
                        startIcon={<DeleteIcon />}
                      >
                        Delete
                      </MaterialButton>
                    </ButtonGroup>
                  )}
              </Stack>
            </>
          }
        />
        <CardContent>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Job ID <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="jobid"
                  value={feedback.jobid}
                  customStyles={{ optionPadding: 20 }}
                  error={feedback.jobidStatus === "error" ? true : false}
                  success={feedback.jobidStatus === "success" ? true : false}
                  disabled={true}
                  //   isClearable
                />
              </Grid>

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Candidate Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="candidatename"
                  value={feedback.candidatename}
                  customStyles={{ optionPadding: 20 }}
                  disabled={true}
                  //   isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Interview Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="date"
                  type="datetime-local"
                  value={feedback.date}
                  disabled={true}
                  //   isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Position <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="position"
                  value={feedback.position}
                  disabled={true}
                  //   isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Department <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="department"
                  value={feedback.department}
                  customStyles={{ optionPadding: 20 }}
                  disabled={true}
                  //   isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Interviewer <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="interviewer"
                  value={feedback.interviewer}
                  customStyles={{ optionPadding: 20 }}
                  disabled={true}
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <Table sx={tableStyles.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Characteristics</TableCell>
                      {ratings.map((rating) => (
                        <TableCell key={rating}>{rating}</TableCell>
                      ))}
                    </TableRow>

                    <TableBody>
                      {characteristics.map((char, index) => {
                        // Convert to camelCase to match selectedRatings keys
                        const charKey = char
                          .split(" ")
                          .map((word, idx) =>
                            idx === 0
                              ? word.toLowerCase()
                              : word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase()
                          )
                          .join("");

                        console.log(
                          "char:",
                          char,
                          "charKey:",
                          charKey,
                          "Selected Value:",
                          selectedRatings[charKey]
                        );

                        return (
                          <TableRow key={`${char}-${index}`}>
                            <TableCell>{char}</TableCell>
                            {ratings.map((rating) => (
                              <TableCell key={`${char}-${rating}`}>
                                <Checkbox
                                  name={charKey}
                                  value={rating}
                                  disabled={togglePage.view}
                                  color="primary"
                                  checked={
                                    selectedRatings[charKey] ===
                                    ratingValues[rating]
                                  }
                                  onChange={handlefeedbback}
                                />
                              </TableCell>
                            ))}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </TableHead>
                </Table>
              </Grid>
            </Grid>

            <Grid marginTop={2} container spacing={2}>
              <Grid size={{ xs: 5, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Comments <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="comments"
                  multiline
                  rows={4}
                  value={feedback.comments}
                  onChange={(e) => {
                    setfeedback((prev) => ({
                      ...prev,
                      comments: e?.target?.value,
                      commentsStatus: e?.target?.value ? "success" : "error",
                    }));
                  }}
                  customStyles={{ optionPadding: 20 }}
                  error={feedback.commentsStatus === "error" ? true : false}
                  success={feedback.commentsStatus === "success" ? true : false}
                  disabled={togglePage.view === true ? true : false}
                  //   isClearable
                />
                {feedback.commentsStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      {" "}
                      Comments accept maximum 250 characters.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Hiring Status <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="hiringstatus"
                  value={feedback.hiringstatus}
                  onChange={(e) =>
                    setfeedback((prev) => ({
                      ...prev,
                      hiringstatus: e,
                      hiringstatusStatus: e ? "success" : "error",
                    }))
                  }
                  options={jobidlist.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  error={feedback.hiringstatusStatus === "error" ? true : false}
                  success={
                    feedback.hiringstatusStatus === "success" ? true : false
                  }
                  isDisabled={togglePage.view === true ? true : false}
                  //   isClearable
                />
              </Grid>
            </Grid>

            {/* </TableContainer> */}
          </MaterialBox>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            {/* Left side: Close button (Only visible when editing or viewing) */}
            {(togglePage.edit === true || togglePage.view === true) && (
              <MaterialButton
                variant="gradient"
                color="dark"
                sx={{ m: 2 }}
                onClick={handlecancel}
              >
                Close
              </MaterialButton>
            )}

            {/* Right side: Buttons */}
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
              flexGrow={1}
            >
              {togglePage.edit === true ? (
                <>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={() => navigate("/technical")}
                  >
                    Discard
                  </MaterialButton>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    onClick={handleEdit}
                  >
                    Update
                  </MaterialButton>
                </>
              ) : togglePage.view === false && togglePage.edit === false ? (
                <>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    onClick={handlecancel}
                  >
                    Cancel
                  </MaterialButton>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    sx={{ m: 2, marginLeft: "2px" }}
                    disabled={!checkAllFields()}
                    onClick={handleAddSource}
                  >
                    Submit
                  </MaterialButton>
                </>
              ) : null}
            </MaterialBox>
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};
export default SourceProfile;
